import Vue from 'vue'
import App from './App.vue'

//导入组件+样式
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
//播放器
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'

// vant
import { Toast, Icon,Dialog,Notify,ActionSheet,Button } from 'vant';
Vue.use(Toast);
Vue.use(Icon);
Vue.use(Dialog);
Vue.use(Notify);
Vue.use(ActionSheet);
Vue.use(Button);

//使用
Vue.use(VueAwesomeSwiper)
Vue.use(VueVideoPlayer)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
